import { createSelector } from '@reduxjs/toolkit';
import { selectLocation } from 'shared/selectors/location';
import { selectDirectionsModal } from './selectDirectionsModal';
import { getRegionIdForDirections } from 'shared/utils/geo';

export const selectNeedDirectionsDataRequest = createSelector(
  [selectLocation, selectDirectionsModal],
  (currentLocation, directionsModal) => {
    const currentRegionId = getRegionIdForDirections(currentLocation);
    const { regionId, data } = directionsModal;

    return currentRegionId !== regionId || !data.length;
  },
);
